module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/ma-gallery/ma-gallery-05-48300c617d9161fa9028948b1a9f5d91.jpg";